<template>
  <main>
    <div class="path">
      <i class="el-icon-caret-right"></i>客户管理
      <i class="el-icon-arrow-right"></i>&nbsp;产品列表
    </div>

    <div class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-form :inline="true" label-width="120px">
        <div class="item-wrapper">

          <div class="item-content clearfix">
            <el-form-item label="客户名称" style="margin-bottom: 0px;">
              <el-select v-model="tenantId" @change="getProduct" placeholder="请选择" style="width: 320px;">
                <el-option
                  v-for="item in cusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.username">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

        </div>
      </el-form>
    </div>

    <section class="content_wrapper" :style="'width:' + (wrapperWidth*navCollapse) + 'vw;'">
      <el-table
        :data="tableData.data"
        v-loading="loading"
        stripe
        style="width: 100%">
        <el-table-column
          prop="productName"
          label="产品名称"
          :width="150*navCollapse">
        </el-table-column>

        <el-table-column
          prop="productKey"
          label="产品编号"
          :width="170*navCollapse">
        </el-table-column>

        <el-table-column
          prop="description"
          label="场景描述"
          :width="240*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="licenseCount"-->
<!--          label="License数量"-->
<!--          :width="120*navCollapse">-->
<!--        </el-table-column>-->

<!--        <el-table-column-->
<!--          prop="activeLicenseCount"-->
<!--          label="已激活License数量"-->
<!--          :width="150*navCollapse">-->
<!--        </el-table-column>-->

        <el-table-column
          prop=""
          label="License数量：已激活/总量"
          :width="215*navCollapse">
          <template slot-scope="scope">
            {{scope.row.activeLicenseCount}}/{{scope.row.licenseCount}}
          </template>
        </el-table-column>

        <el-table-column
          prop="maxQps"
          label="QPS"
          :width="110*navCollapse">
        </el-table-column>

        <el-table-column
          prop=""
          label="720P图像数量：已使用/总量（张）"
          :width="250*navCollapse">
          <template slot-scope="scope">
            {{formattedInt(scope.row.usedToken/1348)}}/{{formattedInt(scope.row.tokenCount/1348)}}
          </template>
        </el-table-column>

<!--        <el-table-column-->
<!--          prop=""-->
<!--          label="Token：已使用/总量（万个）"-->
<!--          :width="215*navCollapse">-->
<!--          <template slot-scope="scope">-->
<!--            {{formattedFloat(scope.row.usedToken/10000)}}/{{formattedFloat(scope.row.tokenCount/10000)}}-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column
          prop="createTime"
          label="创建时间"
          :width="170*navCollapse">
        </el-table-column>

<!--        <el-table-column-->
<!--          prop="expireTime"-->
<!--          label="资源到期时间"-->
<!--          :width="168*navCollapse">-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>

    </section>

  </main>
</template>

<style>
.el-table .success-cell {
  background: #F0F9EB;
  font-weight: bold;
}
</style>

<script>
import {mapState} from 'vuex'
import {
  dateTimeFormatter
} from '@/common/utils.js'

import {
  reqProductInfos,
  reqFindAllCustomers
} from '@/api'

export default {
  name: 'AllProduct',

  data() {
    return {
      cusList: [],
      tenantId: '',
      tableData: {},
      loading: true,
      currentPage: 1,
      total: 0,
      pageSize: 15
    }
  },

  async mounted() {
    await this.findAllCustomers()
    await this.getProduct()
  },

  methods: {
    async findAllCustomers() {
      const result = await reqFindAllCustomers('', this.currentPage)
      if (result.code === 0) {
        this.cusList = result.data.list
        // console.log(this.cusList.list[0])
        this.tenantId = this.cusList[0].username
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    formattedFloat (num) {
      return parseFloat(parseFloat(num).toFixed(2)) // 保留两位小数
    },

    formattedInt (num) {
      return parseInt(parseInt(num).toFixed(0))
    },

    async getProduct() {
      this.loading = true
      const result = await reqProductInfos('/product/getProductList', this.tenantId, this.currentPage, this.pageSize)
      if (result.code === 200) {
        this.tableData = result.data
        this.total  = result.data.total
        this.pageSize  = result.data.pageSize

        this.loading = false
      } else {
        this.$message.error('数据查询失败，错误信息: ' + result.message)
      }
    },

    async handleCurrentChange(val) {
      this.currentPage = val
      await this.getProduct()
    },

  },

  computed: {
    ...mapState(['navCollapse', 'wrapperWidth']),
  }

}
</script>

<style scoped>

main {
  /*width: 100%;*/
  display: flex;
  flex-direction: column;
}

.content_wrapper {
  width: 82vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px auto;
}

.tip-ol-box {
  background-color: rgba(96, 149, 242, 0.3);
  padding: 10px 0px;
}

.tip-ol {
  color: #0C129A;
  font-size: 12px;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminCenter/AllProduct/AllProduct.vue